import jQuery from 'jquery/dist/jquery';
import * as bootstrap from 'bootstrap'

import Utils from '../../../../utils'
import DefaultController from "../../../defaultController";
import ErpLabelEntity from '../entity';

export default class ErpLabelList extends DefaultController {
    tableElem: any;
    datatable: any;
    editModal: bootstrap.Modal | undefined;

    async init() {
        this.entity = "erp/labels"
        await super.init();
        await this.loadAll();
    }

    async loadAll() {
        const r = await Utils.entity.getAll(this.entity);
        if (r.status === 200) {
            const entities = r.data;
            await Utils.updateElements(entities.product, '', (document.querySelector("#editErpLabelsProduct") as HTMLFormElement))
            await Utils.updateElements(entities.warehouseLocation, '', (document.querySelector("#editErpLabelsWarehouseLocation") as HTMLFormElement))

        }
    }

    getEntityData(elem: any) {
        return ErpLabelEntity.getEntityData(elem)
    }

    bindListeners() {
        (document.querySelector("#editErpLabelsProduct") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault()
            const elem = document.querySelector("#editErpLabelsProduct") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                await Utils.showLoader();
                await Utils.entity.upsert({product: this.getEntityData(elem)}, this.entity)
                this.toastr.success(`${Utils.translate('erp.label.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)

                await this.loadAll()
                await Utils.hideLoader();
            }
        });
        (document.querySelector("#editErpLabelsWarehouseLocation") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault()
            const elem = document.querySelector("#editErpLabelsWarehouseLocation") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                await Utils.showLoader();
                await Utils.entity.upsert({warehouseLocation: this.getEntityData(elem)}, this.entity)
                this.toastr.success(`${Utils.translate('erp.label.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)

                await this.loadAll()
                await Utils.hideLoader();
            }
        })
    }
}